"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-vendemiano": {
    "7c7f0b53": [{
      "hkey": "0e83259b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "borghetto": [{
      "hkey": "0e83259b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "54f8b979": [{
      "hkey": "4404f9b5",
      "slug": "fossamerlo",
      "name": "Fossamerlo",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-fossamerlo": [{
      "hkey": "4404f9b5",
      "slug": "fossamerlo",
      "name": "Fossamerlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65aa720f": [{
      "hkey": "b54a1bbd",
      "slug": "cosniga-zoppe",
      "name": "Cosniga-Zoppè",
      "primary": true,
      "skipSearch": false
    }],
    "cosniga": [{
      "hkey": "b54a1bbd",
      "slug": "cosniga-zoppe",
      "name": "Cosniga-Zoppè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7abcd54": [{
      "hkey": "0e83259b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "gai": [{
      "hkey": "0e83259b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9094395a": [{
      "hkey": "a553ddc5",
      "slug": "san-vendemiano",
      "name": "San Vendemiano",
      "primary": true,
      "skipSearch": false
    }],
    "visnadello": [{
      "hkey": "a553ddc5",
      "slug": "san-vendemiano",
      "name": "San Vendemiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "607ce14e": [{
      "hkey": "b54a1bbd",
      "slug": "cosniga-zoppe",
      "name": "Cosniga-Zoppè",
      "primary": true,
      "skipSearch": false
    }],
    "zoppe": [{
      "hkey": "b54a1bbd",
      "slug": "cosniga-zoppe",
      "name": "Cosniga-Zoppè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-vendemiano"
    }],
    "53ea0e2b": [{
      "hkey": "b3382897",
      "slug": "saccon",
      "name": "Saccon",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-saccon": [{
      "hkey": "b3382897",
      "slug": "saccon",
      "name": "Saccon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "35360fc4": [{
      "hkey": "0e83259b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-borghetto-gai": [{
      "hkey": "0e83259b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;